module.exports = __webpack_public_path__ + "media/images/event-601293d96c9172099e1059b1d5ac45fd.jpg";